import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Label,
  Form,
  FormFeedback,
  Input,
  Button,
  Spinner,
} from "reactstrap"

import { useTranslation } from "react-i18next"

import { Link } from "react-router-dom"

const LoginForm = ({ validation, loading, activeTab }) => {
  const { t } = useTranslation()
  const getRoleLabel = () => {
    return activeTab === "1" ? t("login.roleClub") : t("login.roleAgent")
  }
  return (
    <>
      <h4 className="text-center mt-3 mb-4">
        {t("login.connectAs", { role: getRoleLabel() })}
      </h4>

      <Form
        className="mt-4"
        onSubmit={(e) => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
        action="#"
      >
        <div className="mb-3">
          <Label className="form-label" htmlFor="username">
            {t("login.email")} {/* Traduction de "Username" */}
          </Label>
          <Input
            name="email"
            className="form-control"
            placeholder={t("login.enterEmail")}
            type="email"
            id="username"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.email || ""}
            invalid={
              validation.touched.email && validation.errors.email ? true : false
            }
          />
          {validation.touched.email && validation.errors.email ? (
            <FormFeedback type="invalid">
              {validation.errors.email}
            </FormFeedback>
          ) : null}
        </div>

        <div className="mb-3">
          <Label className="form-label" htmlFor="userpassword">
            {t("login.password")} {/* Traduction de "Password" */}
          </Label>
          <Input
            name="password"
            value={validation.values.password || ""}
            type="password"
            className="form-control"
            placeholder={t("login.enterPassword")}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={
              validation.touched.password && validation.errors.password
                ? true
                : false
            }
          />
          {validation.touched.password && validation.errors.password ? (
            <FormFeedback type="invalid">
              {validation.errors.password}
            </FormFeedback>
          ) : null}
        </div>

        <div className="mb-3 row">
          <div className="col-sm-6">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="customControlInline"
              />
              <label className="form-check-label" htmlFor="customControlInline">
                {t("login.rememberMe")} {/* Traduction de "Remember me" */}
              </label>
            </div>
          </div>
          <div className="col-sm-6 text-end">
            {loading ? (
              <Button
                color="primary"
                disabled
                className="w-md waves-effect waves-light"
              >
                <Spinner size="sm" className="me-2" />
                <span>{t("loading")}</span>
              </Button>
            ) : (
              <Button
                className="btn btn-primary w-md waves-effect waves-light"
                type="submit"
              >
                {t("login.logInButton")}
              </Button>
            )}
          </div>
        </div>

        <div className="mt-2 mb-0 row">
          <div className="col-12 mt-4">
            <Link to="/forgot-password">
              <i className="mdi mdi-lock"></i> {t("login.forgotPassword")}{" "}
              {/* Traduction de "Forgot your password?" */}
            </Link>
          </div>
        </div>
      </Form>
    </>
  )
}

export default LoginForm
